$(document).ready(function () {

	var navbar = $('.navbar');
	var navbarHeight = navbar.outerHeight();
	var announcement_bar = $('.announcement-bar');
	var btn_navDrawer = $('#btn-nav-menu-drawer');

	// Navbar scroll effects

	let scrollTargetPosition = 50;

	$(window).scroll(function () {
		if ($(this).scrollTop() > scrollTargetPosition) {
			navbar.addClass('is-scrolled');
			scrollTargetPosition = 0;
		} else {
			navbar.removeClass('is-scrolled');
			scrollTargetPosition = 50;
		}
	});

	// Navigation drawer

	btn_navDrawer.click(function (e) {
		e.preventDefault();

		var navbar_total_height;

		if (announcement_bar.length === 0) {
			navbar_total_height = navbarHeight;
			console.log('no announcement');
		} else {
			navbar_total_height = navbarHeight + announcement_bar.outerHeight();
			console.log('has announcement');
		}
		let drawer = $(this).data('target');
		
		console.log(navbar_total_height);

		$(drawer).css('height', 'calc(100vh - ' + navbar_total_height + 'px)');

		if ($(this).attr('aria-expanded') == 'true') {
			$(this).attr('aria-expanded', 'false');
			$(navbar).removeClass('is-drawer-open');
			$(drawer).attr('aria-hidden', 'true').addClass('show').removeClass('shown');
			setTimeout(() => {
				$(drawer).removeClass('show');
			}, 200);

		} else if ($(this).attr('aria-expanded') == 'false') {
			$(this).attr('aria-expanded', 'true');
			$(navbar).addClass('is-drawer-open');
			$(drawer).attr('aria-hidden', 'false').addClass('show');
			setTimeout(() => {
				$(drawer).addClass('shown').removeClass('show');
			}, 200);
		}
	});


	// Search

	var btn_search = $('#btn-search');
	var btn_search_dismiss = $('#btn-search-dismiss');

	btn_search.click(function (e) {
		e.preventDefault();

		let searchbox = $(this).data('target');

		$(searchbox).addClass('show').removeClass('hidden');
		$('body').addClass('overflow-hidden');

		setTimeout(() => {
			$(searchbox).addClass('shown').removeClass('show');
			$(searchbox).find('#search-input').val('').focus();
		}, 100);
	});

	btn_search_dismiss.click(function (e) {
		e.preventDefault();

		let searchbox = $(this).data('dismiss');

		$('body').removeClass('overflow-hidden');
		$(searchbox).addClass('show').removeClass('shown');

		setTimeout(() => {
			$(searchbox).addClass('hidden').removeClass('show');
		}, 100);
	});

	$(document).on('keydown', function (e) {
		if ($('#search-modal').hasClass('shown')) {
			if (e.keyCode === 27) {
				$('body').removeClass('overflow-hidden');
				$('#search-modal').addClass('show').removeClass('shown');

				setTimeout(() => {
					$('#search-modal').addClass('hidden').removeClass('show');
				}, 100);
			}
		}
	});


	// Offset homepage hero section

	$('#s-homepage-hero').css('margin-top', '-' + navbarHeight + 'px');


	// Show / Hide account form

	$('.btn-toggle-account-form').click(function (e) {
		e.preventDefault();

		let modal_show = $(this).data('form-show');
		let modal_hide = $(this).data('form-hide');

		$(modal_hide).hide();
		$(modal_show).show();
	});


	// Quantity selectors
	
	$('.btn-qty-minus').click(function() {
		var inputQty = $(this).parent().parent().find('input');
	
		if (inputQty.val() > 1) {
			inputQty.val(+inputQty.val() - 1);			
		}
	});

	$('.btn-qty-plus').click(function() {
		var inputQty = $(this).parent().parent().find('input');

		if (inputQty.val() < 10) {
			inputQty.val(+inputQty.val() + 1);			
		}
	});
	

	// Slick

	try {
		$('.slick-product-img-highlight').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: '<button type="button" class="btn-slick-arrow prev">' +
							'<img src="https://cdn.shopify.com/s/files/1/1056/8792/files/arrow.png?v=1648119188">' +
						'</button>',
			nextArrow: '<button type="button" class="btn-slick-arrow next">' + 
							'<img src="https://cdn.shopify.com/s/files/1/1056/8792/files/arrow.png?v=1648119188">' +
						'</div>',
			dots: false,
			draggable: true,
			fade: true,
			infinite: true,
			asNavFor: '.slick-product-thumbnail-nav',
		});
	
		$('.slick-product-thumbnail-nav').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			arrows: false,
			dots: false,
			draggable: true,
			focusOnSelect: true,
			infinite: true,
			asNavFor: '.slick-product-img-highlight',
			responsive: [{
				breakpoint: 511.98,
				settings: {
					slidesToShow: 4,
				}
			}]
		});
	} catch (product_carousel_error) { }
});